export enum EventState {
    OpenEvent = "OPEN_EVENT",
    LiveEvent = "LIVE_EVENT",
}
